export default __webpack_public_path__ + "static/media/ebayLogo.4dba71a6.png";